<template>
  <v-container fluid grid-list-lg mt-5>
    <v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs12 sm3 md3 lg3>
          <single-value
            :total="total"
            :func="'storedDataSize'" />
        </v-flex>
        <v-flex d-flex xs12 sm3 md3 lg3>
          <single-value
          :numberDevice="numberDevice"
          :func="'numOfType'" />
        </v-flex>
        <v-flex d-flex xs12 sm3 md3 lg3>
          <single-value
            :licen="licen"
            :total="total"
            :bpd="bpd"
            :func="'estRetention'" />
        </v-flex>
        <v-flex d-flex xs12 sm3 md3 lg3>
          <single-value
            :total="total"
            :func="'availableDisk'"
            :licen="licen" />
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout mt-5>
      <v-flex>
        <get-License
          :Customer="Customer"
          :start_date="start_date"
          :end_date="end_date"
          :total="total"
          :bpd="bpd"
          :licen="licen"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import getLicense from '@/components/getLicense'
import jwtDecode from 'jwt-decode'
import singleValue from '@/components/singleValue'
import axios from 'axios'

export default {
  name: 'license',
  components: {
    getLicense,
    singleValue
  },
  props: {
    isExpired: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      token: '',
      user_index: '',
      user_inst: '',
      decoded: '',
      index: '',
      Customer: '',
      start_date: new Date(0),
      end_date: new Date(),
      numberDevice: 0,
      total: 0,
      licen: '',
      bpd: 0
    }
  },
  created () {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.index = this.decoded.index
    this.user_index = this.index
    this.user_inst = this.decoded.instance
    this.username = this.decoded.username
    this.Query()
  },
  methods: {
    async Query () {
      await axios.post(apiUrl + '/api/status/getuserVolume', {
        username: this.username
      }).then(response => {
        for (let element of response.data.volume) {
          this.Customer = element.customer_name
          this.start_date = new Date(element.start_date)
          this.end_date = new Date(element.end_date)
          this.numberDevice = element.data.length
          this.licen = element.licen
          for (let data of element.data) {
            this.total = this.total + data.volume
            if (data.byteperday) {
              this.bpd = this.bpd + parseInt(data.byteperday)
            }
          }
        }
      }).catch(e => {
        console.log(e.response.data.errmsg)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/license.vue